export const HOTJAR_EVENT_LIST = {
  originalHeaderVariant: 'original_header_variant',
  tierOneSignup: 'tier1_signup',
  emptyEmailOnTierOneSignUp: 'tier1_signup_empty_email',
  saveLegalAddressAsShippingAndBilling: 'save_address_variant_on_tier_two_signup',
  originalVariantOnTierTwoSignup: 'original_variant_on_tier_two_signup',
  addressesAsLegalSaved: 'save_address_variant_on_tier_two_signup_address_step',
  addressesAsLegalNotSaved: 'not_save_address_variant_on_tier_two_signup_address_step',
  accountExistenceCheck: 'account_existence_check',
};
